import { render } from "./PartnerSectionFour.vue?vue&type=template&id=3490b816"
import script from "./PartnerSectionFour.vue?vue&type=script&lang=js"
export * from "./PartnerSectionFour.vue?vue&type=script&lang=js"

import "./PartnerSectionFour.vue?vue&type=style&index=0&id=3490b816&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__